import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Search, MessageCircle, Calendar, Heart, Settings, User } from 'lucide-react';

const navItems = [
  { to: '/dashboard/find', label: 'Find a Friend', icon: Search },
  { to: '/dashboard/chats', label: 'My Chats', icon: MessageCircle },
  { to: '/dashboard/bookings', label: 'My Bookings', icon: Calendar },
  { to: '/dashboard/favourites', label: 'Favourites', icon: Heart },
  { to: '/dashboard/settings', label: 'Settings', icon: Settings },
];
const providerNav = [
  { to: '/dashboard/profile', label: 'My Profile', icon: User },
  { to: '/dashboard/chats', label: 'My Chats', icon: MessageCircle },
  { to: '/dashboard/bookings', label: 'Bookings', icon: Calendar },
  { to: '/dashboard/settings', label: 'Settings', icon: Settings },
];

const DashboardLayout = () => {
  const { userProfile, signOut } = useAuth();
  const location = useLocation();
  const isProvider = userProfile?.role === 'service_provider';
  const items = isProvider ? providerNav : navItems;

  return (
    <div className="min-h-screen bg-slate-900 text-slate-200 flex flex-col">
      <header className="bg-slate-900/95 border-b border-white/10 sticky top-0 z-40 backdrop-blur">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <Link to="/dashboard" className="flex items-center shrink-0 py-1" aria-label="Stranger69.net Home">
              <img src="/st69_logo_new.png" alt="Stranger69.net" className="h-10 w-auto object-contain" />
            </Link>
            <nav className="flex items-center gap-1">
              {!isProvider && userProfile?.subscriptionStatus !== 'premium' && userProfile?.subscription_status !== 'premium' && (
                <Link
                  to="/payment"
                  className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium bg-amber-500 text-white hover:bg-amber-600"
                >
                  Upgrade
                </Link>
              )}
              {items.map(({ to, label, icon: Icon }) => (
                <Link
                  key={to}
                  to={to}
                  className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname === to
                      ? 'bg-white/10 text-brand-pink'
                      : 'text-white/90 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  <span className="hidden sm:inline">{label}</span>
                </Link>
              ))}
            </nav>
            <button
              type="button"
              onClick={() => signOut()}
              className="text-white/80 hover:text-white text-sm font-medium"
            >
              Logout
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
